import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import Home from './components/Home';
import Projects from './components/Projects';
import Resume from './components/Resume';

import MyNavbarButtons from './components/MyNavbarButtons';

import './App.css';

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <MyNavbarButtons />

          <Route exact path="/" component={Home} />
          <Route path="/projects" component={Projects} />
          <Route path="/Resume" component={Resume} />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx